import React from 'react'
import SalonPage from './SalonPage.js'
import Host from './Host.js'
import Member from './Member.js'

function ChoisirSalon(props) {
  const {name, onBack, ..._props} = props;

  const [connection, setConnection] = React.useState(null);

  function onBackSalon() {
    window.history.pushState({}, '', '/');
    connection.close();
  }

  return <>
    <h1>Salut {name} !</h1>
    <hr/>
    {
      connection ?
        <SalonPage connection={connection} onBack={onBackSalon}/>
        :
        <ChoisirForm name={name} setConnection={setConnection} onBack={onBack}/>
    }
  </>
}

function ChoisirForm(props) {
  const {name, setConnection, onBack, ..._props} = props;

  const [join, setJoin] = React.useState(false);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    let params = new URLSearchParams(window.location.search);
    if(params.has('code')) {
      let host = params.has('host') && params.get('host');
      let code = params.get('code');

      if(host)
        creerSalon(code);
      else
        setJoin(true);
    }
  }, [setJoin, creerSalon]);

  function creerSalon(code=null) {
    const connection = new Host(name, {
      code,
      onReady() {
        // setLoading(false);
        setConnection(connection);
      },
      onError(err) {
        console.log('ERROR')
        console.log(err)

        // setLoading(false);
        setConnection(null);
        setError(err.message);
      },
      onClose() {
        // setLoading(false);
        setConnection(null);
      },
    });
  }

  if(join)
    return <JoinForm name={name} setConnection={setConnection} onBack={() => setJoin(false)}/>
  else
    return <>
      <p>Créer ou rejoindre un salon ?</p>
      <div className="buttons">
        <button className="btn btn-primary" type="button" onClick={() => creerSalon()}>Créer</button>
        <button className="btn btn-secondary" type="button" onClick={() => setJoin(true)}>Rejoindre</button>
        <button className="btn btn-secondary" type="button" onClick={onBack}>Retour</button>
      </div>
      {error && <div className="text-danger">
        {error}
      </div>}
    </>
}

function JoinForm(props) {
  const {name, setConnection, onBack, ..._props} = props;

  const [codeValue, setCode] = React.useState('');
  const [errors, setErrors] = React.useState({});
  const [loading, setLoading] = React.useState(false);

  const [_connection, _setConnection] = React.useState(null);

  React.useEffect(() => {
    let params = new URLSearchParams(window.location.search);
    if(!_connection && params.has('code')) {
      let host = params.has('host') && params.get('host');
      let code = params.get('code');

      if(!host)
        rejoindreSalon(code);
    }
  }, [_connection, rejoindreSalon]);

  function rejoindreSalon(code) {
    const connection = new Member(code, name, {
      onReady() {
        // setLoading(false);
        setConnection(connection);
      },
      onError(err) {
        console.log('ERROR')
        console.log(err)

        // setLoading(false);
        setConnection(null);

        if(err.message.includes('is taken'))
          setErrors({code: "Nom déjà utilisé."});
        else
          setErrors({code: "Erreur: "+err.message});
      },
      onClose() {
        // setLoading(false);
        setConnection(null);
      },
    });
    _setConnection(connection);
  }

  function onChangeCode(e) {
    setCode(e.target.value);
  }

  function onSubmit(e) {
    e.preventDefault();

    let errors = {};
    if(codeValue.trim().length === 0)
      errors.code = "Il faut indiquer le code du salon !";

    setErrors(errors);

    if(Object.values(errors).length === 0) {
      setLoading(true);

      let code = codeValue.trim().toUpperCase();
      rejoindreSalon(code);
    }
  };

  if(loading) {
    return <div className="spinner-border" role="status">
      <span className="visually-hidden">Chargement...</span>
    </div>
  }

  return <form onSubmit={onSubmit}>
    <div className="mb-3">
      <div className="input-group has-validation">
        <input type="text" className={"form-control"+(errors.code ? ' is-invalid':'')} value={codeValue} onChange={onChangeCode} id="code" placeholder="Code du salon"/>
        {errors.code && <div id="validationServerUsernameFeedback" className="invalid-feedback">
          {errors.code}
        </div>}
      </div>
    </div>
    <div className="buttons">
      <button type="submit" className="btn btn-primary">Rejoindre</button>
      <button type="button" className="btn btn-secondary" onClick={onBack}>Retour</button>
    </div>
  </form>
}

export default ChoisirSalon